<template>
  <mw-dialog :size="params.size?params.size:'full'" ref="dialog" :footerButton="footerButton"
            :width="params.width?params.width:''" :height="params.height?params.height:''"
            :customClass="params.customClass?params.customClass:''"
             :title="$lang(params.title?params.title:'')" :appendToBody="false" :beforeClose="cancel" :modal="params.modal"
             :showClose="(params.showClose==false)?false:true">
    <mw-inner-page :pageId="params.id"  :params="params" :dialog="dialog"  ref="page"></mw-inner-page>
  </mw-dialog>
</template>

<script>
  export default {
    props: {
      /**
       *  params.data
       *  id:   (必填)
       *  title: （可选）
       *  size:full    （可选）
       *
       *  showSure:  显示确定按钮
       *  sureName:  确定
       *
       *  showCancel:  显示确定按钮
       *  cancelName:  取消
       *
       *  buttonsScript:自定义button脚本
       *
       */
      params: {
        type: Object
      }
    },
    data() {
      let me=this;
      return {
        dialog:undefined,
        footerButton: []
      }
    },
   created(){
     let me = this;

     if (me.params.buttonsScript)
       eval(me.params.buttonsScript);

      if(me.params.showSure){
        this.footerButton.push({label: $lang(me.params.sureName || '确定'), func: this.sure});
      }
      if(me.params.showCancel){
        this.footerButton.push({label: $lang(me.params.cancelName || '取消'), func: this.cancel, type: 'default'});
      }
   },
    mounted() {
      this.dialog=this.mwRef('dialog');
      setTimeout(()=>{
        this.show();
      },200)
    },
    methods: {
      show() {
        this.mwRef('dialog').show();
      },

      _done(){
        this.mwRef('dialog').hide();
      },

      sure() {
        let me = this, page = me.mwRef('page'),dialog = me.mwRef('dialog');
        if(page.$refs.pageObj._dialogSure){
          page.$refs.pageObj._dialogSure(me.params.func,me._done);
        }else{
          dialog.hide();
        }
      },

      cancel() {
        let me = this, page = me.mwRef('page'),dialog = me.mwRef('dialog');
        if(page.$refs.pageObj._dialogCancel){
          page.$refs.pageObj._dialogCancel(me.params.func,me._done);
        }else{
          this.mwRef('dialog').hide();
        }
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/components/page.vue